import { render, staticRenderFns } from "./oauthV5.vue?vue&type=template&id=fd74a35e&scoped=true"
import script from "./oauthV5.vue?vue&type=script&lang=js"
export * from "./oauthV5.vue?vue&type=script&lang=js"
import style0 from "./oauthV5.vue?vue&type=style&index=0&id=fd74a35e&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd74a35e",
  null
  
)

export default component.exports